<template>
  <div class="extra-style-template">
    <pages-wrapper>
      <div class="template-wrapper" v-for="(photo, index) in photoList" :key="index">
        <van-radio-group v-model="selectedTemplateCode">
          <van-radio :name="photo.templateCode">
            <div class="template">
              <img :src="getTemplateSrc(photo.templateCode)">
            </div>
          </van-radio>
        </van-radio-group>
      </div>
    </pages-wrapper>
    <div class="next-btn">
      <img src="../../assets/images/extra-style/next.png" @click="hanldeNextStep">
    </div>
  </div>
</template>

<script>
import PagesWrapper from './components/pages-wrapper'
export default {
  name: 'ExtraStyleTempalte',
  components: {
    PagesWrapper
  },
  created () {
    this.initTemplate()
  },
  data () {
    return {
      userInfo: null,
      // 当月模板图片总张数
      currentTemplateNum: 1,
      photoList: [],
      selectedTemplateCode: ''
    }
  },
  methods: {
    hanldeNextStep () {
      const query = {
        templateCode: this.selectedTemplateCode
      }
      this.$router.push({ path: '/extra-style/upload-image', query: query })
    },
    getTemplateSrc (code) {
      const src = require('../../assets/images/extra-style/' + code + '.png')
      return src
    },
    initTemplate () {
      const currentMonth = new Date().getMonth() + 1
      this.selectedTemplateCode = currentMonth + '-1'
      if (currentMonth <= 3) {
        for (let i = 1; i <= this.currentTemplateNum; i++) {
          for (let j = 1; j <= currentMonth; j++) {
            this.photoList.push({ templateCode: j + '-' + i })
          }
        }
      } else {
        for (let i = 1; i <= this.currentTemplateNum; i++) {
          this.photoList.push({ templateCode: currentMonth + '-' + i })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.extra-style-template {
  position: relative;
  width: 100%;
  min-height: calc(100vh);
  font-size: 0;
  background: url('../../assets/images/extra-style/bg.jpg') no-repeat;
  background-size: 100% 100%;
  img {
    width: 100%;
  }
  .template-wrapper {
    width: 48%;
    padding: 10px 1% 0 1%;
    .template {
      position: relative;
    }
    .template img {
      position: relative;
      width: 100%;
      z-index: 1;
    }
  }
}
.next-btn {
  z-index: 3;
  position: fixed;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 10px 0;
  margin: auto;
  text-align: center;
  img {
    width: 120px;
  }
}
</style>
